import React from 'react'
import { Link } from 'gatsby'
import StandardContainer from '../StandardContainer'
import logo from './logo2.png'
import styles from './StandardHeader.module.scss'

export const StandardHeader = () => (
  <header className={styles.header}>
    <StandardContainer>
      <Link to="/" className={styles.homepageLink}><img src={logo} alt="logo" /></Link>
    </StandardContainer>
  </header>
)
